import { FaRegFilePowerpoint, FaRegFileWord } from "react-icons/fa";
import { Filename, Wrapper } from "./styles";
import { BiTrash } from "react-icons/bi";
import { useHistory } from "react-router";

type CardProps = {
  id: number;
  extension: string;
  filename: string;
  onOpenRemoveTemplateModal: (id: number, filename: string) => void;
};

export default function TemplateCard({
  extension,
  filename,
  id,
  onOpenRemoveTemplateModal,
}: CardProps) {
  const history = useHistory();

  function handleGoToForm() {
    history.push(`/show-contract-templates/${id}`);
  }

  function handleDeleteTemplate(e: React.MouseEvent<SVGElement>) {
    e.stopPropagation();
    onOpenRemoveTemplateModal(id, filename);
  }

  return (
    <Wrapper onClick={handleGoToForm}>
      <BiTrash className="delete-icon" onClick={handleDeleteTemplate} />
      {extension === "pptx" ? (
        <FaRegFilePowerpoint style={{ color: "#D24726" }} />
      ) : (
        <FaRegFileWord style={{ color: "#2B579A" }} />
      )}
      <Filename>{filename}</Filename>
    </Wrapper>
  );
}
